'use strict';

var _tslib = require('../../../../../_virtual/_tslib.js');
var File_constants = require('../../File/constants/File.constants.js');

var IMAGE_CDN_FORMATS = {
    AUTO: "auto",
    AVIF: File_constants.images_format_keys.avif,
    JPEG: File_constants.images_format_keys.jpeg,
    JPG: File_constants.images_format_keys.jpg,
    PNG: File_constants.images_format_keys.png,
    WEBP: File_constants.images_format_keys.webp,
    SVG: File_constants.images_format_keys.svg,
    TIFF: File_constants.images_format_keys.tiff,
};
var ACCEPTED_IMAGES_FORMAT_IN_OPTIMIZATING_CDN = _tslib.__spreadArray(_tslib.__spreadArray(_tslib.__spreadArray(_tslib.__spreadArray(_tslib.__spreadArray(_tslib.__spreadArray(_tslib.__spreadArray([], File_constants.file_mime_types[File_constants.images_format_keys.png], true), File_constants.file_mime_types[File_constants.images_format_keys.jpeg], true), File_constants.file_mime_types[File_constants.images_format_keys.jpg], true), File_constants.file_mime_types[File_constants.images_format_keys.avif], true), File_constants.file_mime_types[File_constants.images_format_keys.svg], true), File_constants.file_mime_types[File_constants.images_format_keys.tiff], true), File_constants.file_mime_types[File_constants.images_format_keys.webp], true);

exports.ACCEPTED_IMAGES_FORMAT_IN_OPTIMIZATING_CDN = ACCEPTED_IMAGES_FORMAT_IN_OPTIMIZATING_CDN;
exports.IMAGE_CDN_FORMATS = IMAGE_CDN_FORMATS;
//# sourceMappingURL=ExlyImage.constants.js.map
